import { Fragment, useState } from "react";
import { Col, Row, Form, Card, Button, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import API from "../../../services/axiosInstance";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
import { FormLoader, useFormLoader } from "../../common_modules/loader";

const PubDefinition = () => {
    const [userInfo, setUserInfo] = useState();
    const { handleSubmit, register, resetField, setValue, reset, watch, formState: { errors } } = useForm({
        shouldUnregister: false,
        defaultValues: {
            idType: "1",
            id: "",
            entityType: "2",// for only publisher
        },
    });
    const [idType, id, entityType] = watch(["idType", "id", "entityType"]);
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const onSubmitHandler = async (data) => {
        startLoading();
        try {
            const response = await API.post(`meta/id/definition/get`, data);
            if (response.status === 200) {
                const data = response.data.data;
                setUserInfo(data);
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>Meta Admin</span>
                <span>Publisher Definition</span>
            </div>
            <Card className="p-3 instreamRows">
                <h6 className="title">Publisher Id Definition</h6>
                <span className="text-danger mb-5" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <form onSubmit={handleSubmit(onSubmitHandler)}>
                    <Row>
                        <Col md={3}>
                            <label>Id Type<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Select name="idType" value={idType} {...register("idType", {
                                required: "idType is required",
                                onChange: () => setValue("id", "")
                            })}>
                                <option value="1">ID</option>
                                <option value="2">GUID</option>
                            </Form.Select>

                            {errors.idType && (
                                <p className="text-danger">{errors.idType.message}</p>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <label>{idType == 1 ? "ID" : "GUID"}<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Control type="text" className="form-control" name="id" placeholder="Enter here..." {...register("id", { required: `${idType == 1 ? "Id" : "Guid"} is required` })} />
                            {errors.id && <p className="text-danger">{errors.id.message}</p>}
                        </Col>
                    </Row>
                    <Permission code={AUTH_CODE.defination.getIdDefination}>
                        <Row>
                            <Col>
                                <Button type="submit" className="btn btn-primary" size="md">Search</Button>
                            </Col>
                        </Row>
                    </Permission>
                </form>


                <Table striped bordered hover className='mt-3'>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Guid</th>
                            <th>Name</th>
                        </tr>
                    </thead>
                    {userInfo &&
                        <tbody>
                            {/* {
                                userInfo.map((item, index) => { */}
                            <tr key={0} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * 0 }} className="hover-glow">
                                <td>{userInfo.id}</td>
                                <td>{userInfo.guid}</td>
                                <td>{userInfo.name}</td>
                            </tr>
                            {/* }) */}
                            {/* } */}
                        </tbody>
                    }
                </Table>

                <center> {!userInfo && "No Data Found !!!"}</center>
            </Card>
        </FormLoader>
    );
}

export default PubDefinition;